/* eslint-disable max-len */

import { defineMessages } from 'react-intl'

export default defineMessages({
  btnShowMore: 'Show more',
  defaultTitle: '100+ clients from all kinds of industries have already benefited',
  defaultSubtitle: 'Travel, healthcare, finance, automotive, construction & many more'
})
